import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';



import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';


export default function PlateformeConfirmationDialog({ open, onCancel, onValid, plateformeCode, onChangePlateformeCode }) {

  return (
      <Dialog open={open} onClose={onCancel}>
          <DialogTitle>Génération de la packing list - Choix de la plateforme</DialogTitle>
          <DialogContent sx={{ minHeight: "200px" }}>

              <DepotGestionAutocomplete
                  value={plateformeCode}
                  onChange={(e, code) => { console.log(code); onChangePlateformeCode({ target: { name: "PlateformeCode", value: code } }); }}
                  plateformesSeulement required autoFocus label="Veuillez sélectionner une plateforme" modeTri={ 1} />
          </DialogContent>
          <DialogActions>
              
              <Button onClick={onCancel} color="primary">
                  Annuler
              </Button>

              <Button
                  onClick={onValid}
                  color="secondary"
                  variant="contained"
                  disabled={!plateformeCode}
              >
                  Continuer
              </Button>

          </DialogActions>
      </Dialog>
  );
}
